import React, { useEffect, useState } from "react";
import { Result, Button, Spin } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { api, endpoints } from "../../utils/axiosInstance";

const PageWrapper = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 0 1rem;
  text-align: center;
`;

const PaymentFailed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handlePaymentFailed = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const orderCode = params.get("orderCode");

        if (!orderCode) {
          setError("Không tìm thấy mã đơn hàng");
          setLoading(false);
          return;
        }

        // 1. Kiểm tra trạng thái thanh toán từ PayOS
        const checkStatusResponse = await api.get(
          endpoints.payment.checkStatus(orderCode)
        );

        if (!checkStatusResponse.success) {
          throw new Error("Không thể kiểm tra trạng thái thanh toán");
        }

        await api.put(endpoints.transactionHistory.updateStatus(orderCode), {
          status: "CANCELED",
          reason: "Người dùng đã hủy thanh toán",
        });

        setLoading(false);
      } catch (error) {
        console.error("Error handling failed payment:", error);
        setError(
          error.response?.data?.message ||
            "Có lỗi xảy ra khi xử lý thanh toán thất bại"
        );
        setLoading(false);
      }
    };

    if (location.search) {
      handlePaymentFailed();
    } else {
      setLoading(false);
    }
  }, [location.search]);

  if (loading) {
    return (
      <PageWrapper>
        <Spin size="large" tip="Đang xử lý..." />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Result
        status="error"
        title="Thanh toán thất bại"
        subTitle={
          error || "Giao dịch không thể hoàn tất. Vui lòng thử lại sau."
        }
        extra={[
          <Button
            type="primary"
            key="payment"
            onClick={() => navigate("/payment")}
          >
            Thử lại
          </Button>,
          <Button key="home" onClick={() => navigate("/")}>
            Về trang chủ
          </Button>,
        ]}
      />
    </PageWrapper>
  );
};

export default PaymentFailed;
